// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"m2-z","colorTextValue":"n2-z","swatches":"o2-z","collapseLink":"p2-z","isCollapsed":"q2-z","dropdown":"r2-z","disabled":"s2-z"};